exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".credits {\n  text-align: left;\n  color: #3c3c3c;\n  opacity: 1;\n  font-size: 12px;\n  clear: both;\n  padding-left: 1vh;\n  z-index: 10;\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n  background-color: #dbeefc;\n}\n@media only screen and (max-width: 820px) and (max-height: 820px) {\n  .credits {\n    font-size: 10px;\n  }\n}\n.credits .privacy-policy {\n  float: right;\n  margin-right: 2vh;\n}\n.credits .text {\n  text-decoration: underline;\n  cursor: pointer;\n}\n.credits .text:hover {\n  text-decoration: none;\n  color: #006f88;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();